import axios from "./axios-auth";

const getAllPendingOrders = (
  searchUserOrderId,
  pageNumber,
  pageSize,
  sortField,
  sortOrder
) =>
  new Promise((resolve, reject) => {
    const data = {
      searchuserorderid: searchUserOrderId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      sortField: sortField,
      sortOrder: sortOrder,
    };
    axios({
      url: "/me/pendingorderapproval",
      method: "POST",
      data: data,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

const rejectOrders = (rejectedOrders) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/me/rejectorder",
      method: "POST",
      data: rejectedOrders,
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });

const processApprovedOrders = (approvedOrders) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/me/processapprovedorders",
      method: "POST",
      data: approvedOrders,
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
export { getAllPendingOrders, rejectOrders, processApprovedOrders };
